import React from 'react'

import { Box, Display, FontWeight, Text } from '@gousto-internal/citrus-react'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { DeliveryCard } from 'routes/Checkout/Components/Delivery/DeliveryCard'
import { getBasketDate, getBasketSlotId } from 'selectors/basket'
import { getSlotTimes } from 'utils/deliveries'

export const DeliveryInfoCard = () => {
  const date = useSelector(getBasketDate)
  const deliveryDays = useSelector((state) => (state as any).boxSummaryDeliveryDays)
  const slotId = useSelector(getBasketSlotId)

  const deliveryDate = moment(date).format('dddd Do MMMM')
  const deliveryTime = getSlotTimes({ date, deliveryDays, slotId })

  return (
    <DeliveryCard iconName="icon-calendar" cardStyle="blue">
      <Box display={Display.InlineFlex}>
        <Text size={2}>
          Your selected delivery day is{' '}
          <Text display={Display.Inline} fontWeight={FontWeight.Bold}>
            {deliveryDate},{' '}
          </Text>
          <Text display={Display.Inline} uppercase>
            {deliveryTime}
          </Text>
        </Text>
      </Box>
    </DeliveryCard>
  )
}
